enum Panels {
  PENDING_MAPPING = "mapping_status",
  PENDING_APPROVAL = "pending_customers",
  ALL = "All",
  ARCHIVED = "archived",
  HQSUMMARY = "hqSummary",
}

export default Panels;
